module.exports = __webpack_public_path__ + "static/pp3-4408b4ac4f29c7b78b821c60ac545c44.png";